import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'
import { useQuery } from 'react-query'
import JOB_STATES from '../../constants/job-states'
import { sortBy } from 'lodash'

const useJobs = () => {
    const cacheKeys = useCacheKeys()
    const { api, endpoints, time } = useApi()

    const { data, isLoading, isFetching } = useQuery(
        cacheKeys.JOBS,
        () => api.get(endpoints.jobs),
        {
            staleTime: time.HOUR,
        }
    )

    return {
        isLoading: isLoading || isFetching,
        jobs: data ?  sortBy(data, ['name']) : [],
        states: JOB_STATES,
    }
}

export default useJobs